import { Grid } from '@mui/material';

import { Typography } from '@occc/ui-design-system';
import { ProductGroupSelectField, Select } from '@occc-app/design-system';
import { Earning_Mechanism_Product_Counting_Rounding_Strategy } from '@occc/graphql';
import styled from '@emotion/styled';

const selectData = [
  {
    value: Earning_Mechanism_Product_Counting_Rounding_Strategy.Raw,
    label: 'Raw',
  },
  {
    value: Earning_Mechanism_Product_Counting_Rounding_Strategy.Down,
    label: 'Down',
  },
  {
    value: Earning_Mechanism_Product_Counting_Rounding_Strategy.HalfUp,
    label: 'Half Up',
  },
];

const GridItem = styled(Grid)({
  minWidth: 'fit-content',
});

export const BaseEarnConfiguration = () => {
  return (
    <Grid container spacing={3}>
      <GridItem item sm={3}>
        <Typography variant='subtitle1' paragraph>
          For each purchased item
        </Typography>
        <Select
          name='baseEarn.roundMoneyAmount'
          label='Rounded'
          data={selectData}
          formControlProps={{ size: 'medium', margin: 'none' }}
        />
      </GridItem>
      <GridItem item xs={9}>
        <Typography variant='subtitle1' paragraph>
          Excluding
        </Typography>
        <ProductGroupSelectField
          inputProps={{
            margin: 'none',
          }}
          name='baseEarn.ineligibleProductGroups'
          label='Excluded Product groups'
        />
      </GridItem>
    </Grid>
  );
};
